import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import {
  Search,
  Shield,
  Laptop,
  Smartphone,
  Calendar,
  DollarSign,
} from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
function AdminOrderList() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const orders = [
    {
      id: "#SK2540",
      name: "Neal Matthews",
      date: "07 Oct, 2021",
      total: "$400",
      status: "Paid",
      method: "Mastercard",
      productstatus: "Delivered",
    },
    {
      id: "#SK2541",
      name: "Jamal Burnett",
      date: "07 Oct, 2021",
      total: "$380",
      status: "Chargeback",
      method: "Visa",
      productstatus: "Transit",
    },
    {
      id: "#SK2542",
      name: "Juan Mitchell",
      date: "06 Oct, 2021",
      total: "$384",
      status: "Paid",
      method: "Paypal",
      productstatus: "Delivered",
    },
    {
      id: "#SK2543",
      name: "Barry Dick",
      date: "05 Oct, 2021",
      total: "$412",
      status: "Paid",
      method: "Mastercard",
      productstatus: "Delivered",
    },
    {
      id: "#SK2544",
      name: "Ronald Taylor",
      date: "04 Oct, 2021",
      total: "$404",
      status: "Refund",
      method: "Visa",
      productstatus: "NotStarted",
    },
    {
      id: "#SK2545",
      name: "Jacob Hunter",
      date: "04 Oct, 2021",
      total: "$392",
      status: "Paid",
      method: "Paypal",
      productstatus: "Delivered",
    },
  ];

  // Status badge color map
  const statusColors = {
    Paid: "success",
    Refund: "warning",
    Chargeback: "destructive",
  };
  const productstatusColors = {
    Delivered: "success",
    Transit: "warning",
    NotStarted: "destructive",
  };
  return (
    <>
      <div className="space-y-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 mb-1">Order List</h1>
          <p className="text-slate-600">
            Displays a summary of orders to view order details.
          </p>
        </div>

        {/* Search & Filters */}
        <Card>
          <CardContent className="!p-4">
            <div className="flex flex-col lg:flex-row gap-4">
              <div className="flex-1 relative">
                <Search
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400"
                  size={16}
                />
                <Input
                  placeholder="Search by ID, or product..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
              <div className="flex gap-3">
                <Input
                  type="date"
                  placeholder="dd-mm-yyyy"
                  style={{ minWidth: 160 }}
                />
                <Select>
                  <SelectTrigger style={{ minWidth: 160 }}>
                    <SelectValue placeholder="All Categories" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All Categories</SelectItem>
                    <SelectItem value="Skin">Skin</SelectItem>
                    <SelectItem value="hair">Hair Regrowth</SelectItem>
                    <SelectItem value="Sexual">Sexual Health</SelectItem>
                    <SelectItem value="weight">Weight Loss</SelectItem>
                    <SelectItem value="Mental">Mental Health</SelectItem>
                    {/* Add more categories here */}
                  </SelectContent>
                </Select>
                <Select value={statusFilter} onValueChange={setStatusFilter}>
                  <SelectTrigger className="w-40">
                    <SelectValue placeholder="All Statuses" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All Statuses</SelectItem>
                    <SelectItem value="active">Active</SelectItem>
                    <SelectItem value="expired">Expired</SelectItem>
                    <SelectItem value="suspended">Suspended</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Plans Table */}
        <Card>
          <CardContent className="!p-0">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="bg-gray-50">
                    <input type="checkbox" />
                  </TableHead>
                  <TableHead className="bg-gray-50">Order ID</TableHead>
                  <TableHead className="bg-gray-50">Billing Name</TableHead>
                  <TableHead className="bg-gray-50">Date</TableHead>
                  <TableHead className="bg-gray-50">Total</TableHead>
                  <TableHead className="bg-gray-50">Payment Status</TableHead>
                  <TableHead className="bg-gray-50">Payment Method</TableHead>
                  <TableHead className="bg-gray-50">Order Status</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {orders.map((order) => (
                  <TableRow key={order.id}>
                    <TableCell>
                      <input type="checkbox" />
                    </TableCell>
                    <TableCell>
                      <Link to={`/adminorders/orderdetails/${order.id}`}>
                        <p className="font-medium text-slate-900">{order.id}</p>
                      </Link>
                    </TableCell>
                    <TableCell>{order.name}</TableCell>
                    <TableCell>{order.date}</TableCell>
                    <TableCell>{order.total}</TableCell>
                    <TableCell>
                      <Badge
                        variant={statusColors[order.status] || "secondary"}
                        className={
                          order.status === "Paid"
                            ? "bg-green-100 text-green-600"
                            : order.status === "Refund"
                            ? "bg-yellow-100 text-yellow-800"
                            : order.status === "Chargeback"
                            ? "bg-red-100 text-red-600"
                            : ""
                        }
                      >
                        {order.status}
                      </Badge>
                    </TableCell>
                    <TableCell>
                      <span className="inline-flex items-center gap-2">
                        <i className="ri-bank-card-line" /> {order.method}
                      </span>
                    </TableCell>
                    <TableCell>
                      <Badge
                        variant={
                          productstatusColors[order.productstatus] ||
                          "secondary"
                        }
                        className={
                          order.productstatus === "Delivered"
                            ? "bg-green-100 text-green-600"
                            : order.productstatus === "Transit"
                            ? "bg-yellow-100 text-yellow-800"
                            : order.productstatus === "NotStarted"
                            ? "bg-red-100 text-red-600"
                            : ""
                        }
                      >
                        {order.productstatus}
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
export default AdminOrderList;
